import React from 'react'
import { SelfSignupWithSecretLink } from './SelfSignupWithSecretLink'
import { UserExtraValidationSchemaEnum } from 'shared/entities-validator/user-fields-validators'
import { AllowedUserFieldsEnum } from 'shared/accountNameConfig'
import { getSortedUserFields } from '../AuthHelpers'
import {
  AskSecurityQuestionsAndSignUpWithSecretLinkStep,
  useSignupWithLink
} from '../security-questions/AskSecurityQuestionsAndSignUpWithSecretLinkStep'
import { useLoginContext } from '../login/LoginContext'
import { observer } from 'mobx-react'
import { SelfSignupFormFieldsContextType } from '../self-signup/SelfSignupFormFieldsContext'

const useBuildFieldsContext = (): SelfSignupFormFieldsContextType => {
  const ctx = useLoginContext()

  return React.useMemo((): SelfSignupFormFieldsContextType => {
    const privacyPolicyEnabled =
      ctx.organisation?.additionalFieldsConfig?.privacyPolicyEnabled

    const privacyPolicyUrl =
      (privacyPolicyEnabled &&
        ctx.organisation?.additionalFieldsConfig?.privacyPolicyUrl) ||
      null

    const privacyPolicyValidation = privacyPolicyEnabled
      ? [UserExtraValidationSchemaEnum.PRIVACY_POLICY]
      : []

    return {
      fields: [
        ...new Set([
          ctx.isAccountNameLoginOn
            ? AllowedUserFieldsEnum.ACCOUNT_NAME
            : AllowedUserFieldsEnum.EMAIL,
          ...getSortedUserFields(ctx.additionalFieldsList),
          UserExtraValidationSchemaEnum.PASSWORD,
          UserExtraValidationSchemaEnum.PASSWORD_CONFIRMATION,
          ...privacyPolicyValidation
        ])
      ],
      privacyPolicyUrl,
      isAdditionalInfoForm: false
    }
  }, [ctx.organisation, ctx.isAccountNameLoginOn])
}

export const SignupWithSecretLinkUserDataFormStep: React.FC = observer(() => {
  const fieldsContext = useBuildFieldsContext()
  const signupWithLink = useSignupWithLink()
  const ctx = useLoginContext()

  const submit = async () => {
    if (ctx.shouldAskSecurityQuestions()) {
      await ctx.setStepView(AskSecurityQuestionsAndSignUpWithSecretLinkStep)
      return false
    } else {
      return signupWithLink()
    }
  }

  return (
    <SelfSignupWithSecretLink submit={submit} fieldsContext={fieldsContext} />
  )
})

SignupWithSecretLinkUserDataFormStep.displayName =
  'SignupWithSecretLinkUserDataFormStep'
